/** Small numeric helpers shared by the 3D scenes. */

export const rad = (degrees: number) => (degrees * Math.PI) / 180;
export const clamp01 = (v: number) => Math.min(1, Math.max(0, v));
export const lerp = (a: number, b: number, t: number) => a + (b - a) * t;
/** smoothstep: eases in and out */
export const easeInOut = (t: number) => t * t * (3 - 2 * t);
/** a gentler ease with zero acceleration at both ends — used for camera moves */
export const smoother = (t: number) => t * t * t * (t * (t * 6 - 15) + 10);

/** Deterministic pseudo-random numbers, so generated textures look the same on every load. */
export function seededRandom(seed: number): () => number {
  let s = seed >>> 0;
  return () => {
    s = (s * 1664525 + 1013904223) >>> 0;
    return s / 4294967296;
  };
}
